import React from "react";
import { useLang } from "../LangContext";
import { useReveal } from "../hooks/useReveal";
import { Kicker } from "./Mission";
import { Box, Lock, Sparkles } from "lucide-react";

const cardIcons = [Box, Sparkles, Lock];
const cardAccents = [
  "from-orange-500/40 to-pink-500/40",
  "from-fuchsia-500/40 to-violet-500/40",
  "from-cyan-400/40 to-blue-500/40",
];

export const Upcoming = () => {
  const { t } = useLang();
  const ref = useReveal();

  return (
    <section
      id="upcoming"
      data-testid="upcoming-section"
      className="relative py-24 lg:py-32 reveal"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Kicker label={t.upcoming.kicker} />
          <h2 className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
            {t.upcoming.title.split(" ").slice(0, -3).join(" ")}{" "}
            <span className="text-baj-grad">
              {t.upcoming.title.split(" ").slice(-3).join(" ")}
            </span>
          </h2>
          <p className="mt-6 text-lg text-slate-300 leading-relaxed">
            {t.upcoming.text}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.upcoming.cards.map((c, i) => {
            const Icon = cardIcons[i];
            return (
              <div
                key={i}
                data-testid={`upcoming-card-${i}`}
                className="group relative rounded-3xl overflow-hidden border border-white/10 bg-[#0f1422]/80 p-7 hover:-translate-y-1.5 transition-transform duration-300"
              >
                <div
                  className={`absolute -top-12 -right-12 w-48 h-48 rounded-full bg-gradient-to-br ${cardAccents[i]} blur-3xl opacity-50`}
                />
                <div className="relative">
                  <div className="flex items-center justify-between">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-3 py-1.5 text-[10px] uppercase font-bold tracking-[0.2em] text-slate-200">
                      <span className="w-1.5 h-1.5 rounded-full bg-fuchsia-400 animate-pulse" />
                      {c.tag}
                    </div>
                    <Icon
                      className="w-6 h-6 text-fuchsia-300"
                      strokeWidth={2.2}
                    />
                  </div>

                  {/* Wireframe block */}
                  <div className="mt-6 h-32 rounded-2xl bg-gradient-to-br from-white/5 to-white/0 border border-dashed border-white/15 flex items-center justify-center relative overflow-hidden">
                    <div className="absolute inset-0 bg-[repeating-linear-gradient(135deg,rgba(255,255,255,0.04)_0_8px,transparent_8px_16px)]" />
                    <span className="font-display text-xs uppercase tracking-[0.3em] text-slate-400">
                      To be revealed
                    </span>
                  </div>

                  <h3 className="font-display mt-5 text-xl font-bold text-white">
                    {c.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-slate-400">{c.sub}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
